import * as api from 'commons/js/api'

import { navigateTo } from 'commons/js/services/navigate'
import { takeLatest } from 'commons/js/util/promiseUtils'
import Routes from 'commons/js/routes/routes'

export const getBookingAvailability = takeLatest((params) => {
    return api.getBookingAvailability(params)
})

export function navigateToBookingProcess (prebooking) {
    const url = Routes.bookingProcessPath({
        idPrebooking: prebooking.id,
    })

    navigateTo(url)
}
